import { loadLegacyPlugins } from "../legacy_plugins";

$(document).ready((): void => {
  // The rebuilt booking confirmation page (marked .tw-page, see
  // booking.html.erb) replaces this callback's behaviors with the
  // booking-support-modal Stimulus controller. show_booking.html.erb (the
  // separate order-lookup form) and booking#hotel are not rebuilt and
  // still need this to run.
  if (document.querySelector(".tw-page[data-controller='booking-support-modal']")) {
    return;
  }

  // Past the .tw-page check above, so this really is one of the pages still
  // on the old markup -- fetch tooltipster/fancybox now rather than shipping
  // them to every page that never gets here. See ../legacy_plugins.js.
  loadLegacyPlugins().then((): void => {
    $(".tip").tooltipster({ contentAsHTML: true });

    if ($("#air_bad_error").length > 0) {
      setTimeout(function() {
        $.fancybox.open($("#air_bad_error"));
      }, 250);
    }
  });

  // BookingWidgets.load_car_widget();
  // BookingWidgets.load_hotel_widget();
  // BookingWidgets.load_car_widget_actions();
});
